import { QueryClient } from '@tanstack/react-query';
import { ProjectAnimationAssets } from '../../global-types/digital-greetings';
import { AssetTypes } from '../../global-types/initialization-data';
import { projectDetailsQueryOptions } from '../../services/preview';

/**
 * Loads the latest front and inside panel assets required by the DG animation.
 * Throws when the project response has no assets so callers can surface an error.
 */
export const loadProjectDetails = async (
  projectId: string,
  queryClient: QueryClient,
): Promise<ProjectAnimationAssets> => {
  const response = await queryClient.fetchQuery(projectDetailsQueryOptions(projectId));
  const projectAssets = response?.data?.assets;

  if (!projectAssets) {
    throw new Error('Project animation assets were not found');
  }

  return projectAssets.reduce<ProjectAnimationAssets>((animationPreviewAssets, asset) => {
    if (asset.asset_type_code === AssetTypes.FRONT_PANEL || asset.asset_type_code === AssetTypes.INSIDE_PANEL) {
      const existingAsset = animationPreviewAssets[asset.asset_type_code];

      // Projects may contain multiple renders for a panel; animation must use the newest one.
      if (!existingAsset || Date.parse(asset.created_at) > Date.parse(existingAsset.created_at)) {
        animationPreviewAssets[asset.asset_type_code] = asset;
      }
    }

    return animationPreviewAssets;
  }, {});
};
